<template>
    <kgr-multi-select
        display="title"
        :value="selection"
        :options="filteredExams"
        :loading="loading"
        :disabled="disabled"
        searchable
        @post-input="updateSelection($event)"
    />
</template>

<script>
import ClubExamRepository from '../../../../js/repository/club/ClubExamRepository.js';
import MultiSelect from './MultiSelect.vue';

export default {
    components: {
        'kgr-multi-select': MultiSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: Array,
            required: true,
        },
        strictExamineeType: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            clubExams: [],
            selection: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('exam');
        },
        filteredExams() {
            return this.clubExams.filter((clubExam) => {
                if (this.examineeType && clubExam.examineeType !== this.examineeType) {
                    return false;
                }
                return !this.selection.some((selectedExam) => selectedExam.id === clubExam.id);
            });
        },
        examineeType() {
            let examineeType = null;
            if (this.selection.length > 0) {
                examineeType = this.selection[0].examineeType;
            }
            return examineeType;
        },
    },
    created() {
        this.load();
        this.selection = this.value;
    },
    methods: {
        load() {
            ClubExamRepository.findByClubId(this.clubId)
                .then((clubExams) => this.clubExams = clubExams)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        updateSelection(value) {
            if (value.length === 0) {
                this.selection = [];
                this.$emit('input', []);
                this.$nextTick(() => {
                    this.$emit('post-input', []);
                });
            } else if (value.length > 0) {
                this.selection = value;
                this.$emit('input', value);
                this.$nextTick(() => {
                    this.$emit('post-input', value);
                });
            }
        },
    },
};
</script>
